import React from 'react'

export const StarRating = ({ rating, maxRating = 5 }) => {
  const stars = [];
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;
  const emptyStars = maxRating - Math.ceil(rating);

  // SVG Star Paths
  const starPath =
    "M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.2 5.82 22 7 14.14 2 9.27l6.91-1L12 2z";

  // Full Star Component
  const FullStar = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#1E1E1E">
      <path d={starPath} />
    </svg>
  );

  // Empty Star Component
  const EmptyStar = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#D3D3D3">
      <path d={starPath} />
    </svg>
  );

  // Half Star Component (Uses SVG Mask)
  const HalfStar = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
      <defs>
        <linearGradient id="halfGradient">
          <stop offset="50%" stopColor="#1E1E1E" />
          <stop offset="50%" stopColor="#D3D3D3" />
        </linearGradient>
      </defs>
      <path d={starPath} fill="url(#halfGradient)" />
    </svg>
  );

  // Generate Full Stars
  for (let i = 0; i < fullStars; i++) {
    stars.push(<FullStar key={`full-${i}`} />);
  }

  // Add Half Star
  if (hasHalfStar) {
    stars.push(<HalfStar key="half" />);
  }

  // Generate Empty Stars
  for (let i = 0; i < emptyStars; i++) {
    stars.push(<EmptyStar key={`empty-${i}`} />);
  }

  return <div className="d-flex mt-1 gap-1">{stars}</div>;
}
